<template>
  <li
    class="pp-event-item"
    :class="additionalClasses"
    @click="selectItem(itemInfo.productId)"
    @keydown.enter="selectItem(itemInfo.productId)"
    tabindex="0"
  >
    <span class="pp-event-item__event-notice">
      <font-awesome-icon
        v-show="itemSelected"
        icon="check-circle"
        class="event-notice event-notice--selected"
      />
      <font-awesome-icon
        v-show="ticketSelectable && !itemSelected"
        icon="circle"
        class="event-notice event-notice--no"
      />
    </span>
    <span class="pp-event-item__date">
      <template v-if="shouldDisplayLocalisedDate">{{ localisedDate }}</template>
      <template v-if="shouldDisplayShowTitle && shouldDisplayLocalisedDate"><br></template>
      <template v-if="shouldDisplayShowTitle">
        <b>{{ showTitle }}</b>
      </template>
    </span>
    <template v-if="debugging">
        {{ itemInfo.productId }}
      </template>
    <!-- don't show if tickets are available -->
    <span class="pp-event-item__status" :class="statusClasses"  v-if="itemInfo.availabilityStatus != 19">
      <span v-t="eventStatusText(itemInfo.availabilityStatus)"></span>
    </span>
  </li>
</template>

<script>
import { mapState } from "vuex"
import DateTimeItems from "@/util/DateTimeItems"

export default {
  name: "EventItem",
  mixins: [DateTimeItems],
  props: ["showTitle","shouldDisplayShowTitle","shouldDisplayLocalisedDate"],
  computed: {
    statusClasses() {
      return "pp-event-item__status--" + this.itemInfo.availabilityStatus;
    },
    ticketSelectable() {
      switch (this.itemInfo.availabilityStatus) {
        case 19:
        case 18:
        case 17:
          return true;
        default:
          return false;
      }
    },
    additionalClasses() {
      let additionalClasses = [];
      if (!this.ticketSelectable)
        additionalClasses.push("pp-event-item--disabled");
      if (this.eventSelected) additionalClasses.push("pp-event-item--selected");

      return additionalClasses;
    },
    ...mapState(['debugging'])
  },
  methods: {
    selectItem(id) {
      if (this.eventSelected) {
        // already selected, deselect
        this.$emit("selectItem", null);
      } else if (this.ticketSelectable) {
        // event isn't selected and *is* selectable
        this.$emit("selectItem", id);
      }
    },
    eventStatusText(status) {
      switch (status) {
        case 19:
          return "event.status.available";
        case 17:
        case 18:
          return "event.status.limited";
        case 16:
        case -20:
          return "event.status.sold_out";
        case -7:
          return "event.status.cancelled";
        case -8:
          return "event.status.postponed";
        case 20:
          return "event.status.coming_soon";
        case -6:
          return "event.status.temporarily_off_sale";
      }
    },
  },
};
</script>
